import ArticleCard from '@/components/base/ArticleCard';
import { featuredArticles } from '@/mocks/articles';

export default function FeaturedArticles() {
  return (
    <section className="w-full px-6 md:px-10 py-20">
      <div className="text-center mb-12">
        <p className="text-accent-500 text-sm font-medium tracking-widest mb-2">EDITOR'S PICK</p>
        <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900">
          精选推荐
        </h2>
        <p className="mt-3 text-foreground-500 text-sm max-w-xl mx-auto">
          编辑团队精心挑选的优质内容，带你感受校园最美的瞬间
        </p>
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        {featuredArticles.slice(0, 2).map((article) => (
          <ArticleCard key={article.id} article={article} variant="featured" />
        ))}
      </div>
    </section>
  );
}